function renderIcons(icons) {
  icons.forEach((icon) => {
    if (icon.dataset.icon) {
      fetch(`/theme/heroicons/${icon.dataset.icon}.svg`)
        .then((r) =>
          r.status === 200 ? r.text() : '<div class="broken"></div>'
        )
        .then((text) => {
          icon.innerHTML = text;
        })
        .catch(console.error.bind(console));
    }
  });
}

export default renderIcons;
